"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.normalizePassword = void 0;
const utils_1 = require("ethereum-cryptography/utils");
function normalizePassword(password) {
    if (typeof password === "string") {
        return utils_1.utf8ToBytes(password.normalize("NFKD"));
    }
    else {
        return password;
    }
}
exports.normalizePassword = normalizePassword;
